import React,  { Component } from 'react';
import {Toast} from 'primereact/toast';

class Messages extends Component{
    state = {
        error: false
    }

    componentDidUpdate(prevProps, prevState) {
        // setTimeout(()=> {
        //     this.growl.clear();
        // }, 3000)
     
        //this.triggerMessage();

    }

    componentDidMount(){
        this.triggerMessage();
       
       
    }
    triggerMessage = () => {
        if(this.props.message!=='' && this.props.type!==''){
            this.growl.show({severity: this.props.type, summary: null, detail: this.props.message});
        }
    }
    
    
      
    render(){     
        /*
        success
        info
        warn
        error
        */      

        return <Toast ref={(el) => this.growl = el} />
    }
}

export default Messages;